import { createAction, props } from '@ngrx/store';
import { Resource } from 'app/shared/acl/acl.model';
import { Branding, Disclaimers, User, UserDetails } from './user.model';


type UpdateUserProps = {
    user?: Partial<User>;
    details?: Partial<UserDetails>;
    resources?: Resource[];
    disclaimers?: Disclaimers;
}


export const login = createAction('[Auth] Login', props<{ token: string }>());

export const logout = createAction('[Auth] Logout');

export const invalidToken = createAction('[Auth] Invalid token');

export const validTokenPresent = createAction('[Auth] Valid token present', props<{ token: string }>());

export const tokenNotPresent = createAction('[Auth] Token not present');

export const updateUser = createAction('[Auth] Update user', props<UpdateUserProps>());

export const userUpdated = createAction('[Auth] User updated', props<UpdateUserProps>());

export const refreshUser = createAction('[Auth] Refresh user details and allowed resources');

export const clearUserState = createAction('[Auth] Clear User State');

export const refreshCredentials = createAction('[Auth] Refresh Credentials');

export const requestUpdateBranding = createAction('[User] Request Update Branding', props<{ branding: Partial<Branding> }>());

export const updateBranding = createAction('[User] Update Branding', props<{ branding: Partial<Branding> }>());

export const refreshBranding = createAction('[User] Refresh Branding');
